import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
} from '@angular/core';
import {ModalService} from 'app/core/services/modal.service';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() isVisibleClose = false;
    @Input() additionalClassName: string;

    @Output() shown: EventEmitter<boolean> = new EventEmitter<boolean>();

    private element: any;

    constructor(
        private modalService: ModalService,
        private el: ElementRef,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) {}

    ngOnInit(): void {
        this.element = this.el.nativeElement;
        this.element.remove();
    }

    ngOnDestroy(): void {
        this.element.remove();
    }

    open(): void {
        this.renderer.appendChild(document.body, this.element);
        this.shown.emit(true);
    }

    close(): void {
        this.renderer.removeChild(document.body, this.element);
    }
}
